export const OF_TEXT = 'paginator.of_text';
export const PRODUCT_GRID_REGION_ERROR_DESCRIPTION = 'product_grid_region.error_description';
export const PRODUCT_GRID_REGION_NO_PRODUCT_ERROR_DESCRIPTION = 'product_grid_region.no_product_error_description';
export const PAGE_TEXT = 'paginator.page_text';
export const RIGHT_ARROW_ARIA_LABEL = 'paginator.right_arrow_aria_label';
export const LEFT_ARROW_ARIA_LABEL = 'paginator.left_arrow_aria_label';
